/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import TestimonialCard from '@components/UI/YantraCeremony/TestimonialCard';

/**
 * @description Renders the Yantra Section component
 * @param {Array} sectionData - Data
 * @returns {ReactElement} Yantra Section component
 */
const YantraSection = ({ sectionData }) => {
  return (
    <>
      <Box
        bgGradient="linear(180.06deg, #0D0D0D 0.06%, #500004 43.96%)"
        p={{ base: '40px 20px 0', md: '100px 40px' }}
        mt={{ base: '-1px', md: '0' }}
        fontFamily="FedraSansStd-book-i"
        textAlign="center"
        position="relative"
        _before={{
          bgImage: `url('${sectionData[3]?.image?.url}')`,
          display: { base: 'none', md: 'block' },
          content: '""',
          height: '400px',
          width: '500px',
          pos: 'absolute',
          left: '0',
          top: '180px',
        }}
      >
        <Box mb={{ base: '35px', md: '120px' }}>
          <Box
            fontSize={{ base: '18px', md: '20px' }}
            color="#fff"
            margin="0 auto 30px"
            lineHeight={{ base: '32px', md: '36px' }}
            maxW="600px"
            display="block"
            textAlign="center"
            fontFamily="FedraSansStd-book-i"
            padding={{ base: '0', md: '30px' }}
          >
            " {sectionData[0].quote} "
          </Box>
          <LazyLoadImageComponent
            src={sectionData[1]?.image?.url}
            alt={sectionData[1]?.image?.alt}
            title={sectionData[1]?.image?.title}
          />
        </Box>
        <Box maxWidth={{ base: '', md: '998px', lg: '1120px' }} mx="auto">
          <Flex flexDir={{ base: 'column', md: 'row' }} w="100%">
            <TestimonialCard cardData={sectionData[2].testimonials} />
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default YantraSection;
